import swiper from 'swiper';

var staff_store_Main = new swiper ('.js-staff-slider.if-store', {
  direction: 'horizontal',
  loop: true,
  // effect: "fade",
  // slidesPerView: 5,
  speed:1000,
  // autoplay: {
  //   delay: 5000,
  //   disableOnInteraction: false,
  // },
  spaceBetween: 35,
  // centeredSlides: true,
  observer: true,
  observeParents: true,
  preloadImages: false,
  // noSwiping: true,
  slidesPerView: 4,
  autoHeight: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2
  },
  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  navigation: {
    nextEl: '.swiper-button-next.if-store',
    prevEl: '.swiper-button-prev.if-store',
  },
  breakpoints: {
    768: {
      direction: 'horizontal',
      allowTouchMove: true,
      slidesPerView: 2,
      spaceBetween: 18,
    }
  },
});

var staff_office_Main = new swiper ('.js-staff-slider.if-office', {
  direction: 'horizontal',
  loop: true,
  // effect: "fade",
  // slidesPerView: 5,
  speed:1000,
  // autoplay: {
  //   delay: 5000,
  //   disableOnInteraction: false,
  // },
  spaceBetween: 35,
  // centeredSlides: true,
  observer: true,
  observeParents: true,
  preloadImages: false,
  // noSwiping: true,
  slidesPerView: 4,
  autoHeight: true,
  lazy: {
    loadPrevNext: true,
    loadPrevNextAmount: 2
  },
  // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  navigation: {
    nextEl: '.swiper-button-next.if-office',
    prevEl: '.swiper-button-prev.if-office',
  },
  breakpoints: {
    768: {
      direction: 'horizontal',
      allowTouchMove: true,
      slidesPerView: 2,
      spaceBetween: 18,
    }
  },
});
